import __vue_component__ from './IconWrapper.vue.js';

var BitbucketCompareIcon = {
  name: 'BitbucketCompareIcon',
  props: {
    size: {
      type: String
    },
    primaryColor: {
      type: String
    },
    secondaryColor: {
      type: String
    }
  },

  render(h) {
    // eslint-disable-next-line max-len
    return h(__vue_component__, {
      props: { ...this.$props
      },
      domProps: {
        innerHTML: '<svg viewBox="0 0 24 24"><g fill="currentColor"><path d="M10.067 16.441c.334.918 1.306 1.6 2.28 1.6h6.167c.55 0 .996-.444.996-1a1 1 0 0 0-.996-1h-6.167c-.133 0-.355-.156-.401-.284l-.816-2.263-1.063 2.947zM7.94 10.547l-.816-2.263C7.08 8.16 6.851 8 6.722 8H3.998C3.456 8 3 7.552 3 7c0-.556.447-1 .998-1h2.724c.97 0 1.949.686 2.282 1.6L7.94 10.546z"/><path d="M19.51 7a1 1 0 0 0-.996-1h-6.167c-.976 0-1.95.684-2.283 1.605l-2.94 8.152c-.044.123-.273.284-.402.284H3.998a.996.996 0 0 0-.998 1c0 .552.456 1 .998 1h2.724c.972 0 1.953-.689 2.284-1.606l2.94-8.151c.046-.128.268-.284.401-.284h6.167c.55 0 .996-.444.996-1z"/><path d="M17.293 8.293a1 1 0 1 0 1.414 1.414l1.996-1.996a.999.999 0 0 0 0-1.422l-1.996-1.996a1 1 0 0 0-1.414 1.414L18.586 7l-1.293 1.293zm0 10a1 1 0 0 0 1.414 1.414l1.996-1.996a.999.999 0 0 0 0-1.422l-1.996-1.996a1 1 0 0 0-1.414 1.414L18.586 17l-1.293 1.293z"/></g></svg>'
      }
    });
  }

};

export default BitbucketCompareIcon;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Icon/BitbucketCompareIcon.js